import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b0a51a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c0" }, null, -1))
const _hoisted_3 = { class: "caja c1" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "RNC: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Teléfono: "),
  /*#__PURE__*/_createElementVNode("span", null, "(829) 995-1122 ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "E-Mail: "),
  /*#__PURE__*/_createElementVNode("span", null, "admfinancierarodriguez@gmail.com ")
], -1))
const _hoisted_8 = { class: "caja c2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold" }, [
  /*#__PURE__*/_createTextVNode(" Factura de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Crédito Fiscal ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NCF: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Vencimiento: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c7" }, null, -1))
const _hoisted_14 = { class: "caja c3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "RNC Cliente: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nombre o Razón Social: ", -1))
const _hoisted_17 = { class: "caja c4" }
const _hoisted_18 = { class: "table table-hover" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Descripción"),
  /*#__PURE__*/_createElementVNode("th", null, "Valor")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "t izq" }, "Honorarios Profesionales", -1))
const _hoisted_21 = { class: "t der" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"caja c7\" data-v-6b0a51a5></div><div class=\"caja c5\" data-v-6b0a51a5><h6 class=\"bold\" data-v-6b0a51a5>Sub Total</h6><h6 class=\"bold\" data-v-6b0a51a5>Descuento</h6><h6 class=\"bold\" data-v-6b0a51a5>Total</h6></div>", 2)
const _hoisted_24 = { class: "caja c6" }
const _hoisted_25 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(this.currentFactura.emisor), 1),
        _createElementVNode("h5", null, _toDisplayString(this.currentFactura.direccionEmisor), 1),
        _createElementVNode("h5", null, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(this.currentFactura.rncEmisor), 1)
        ]),
        _hoisted_6,
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("h5", null, [
          _hoisted_10,
          _createElementVNode("span", null, _toDisplayString(_ctx.currentFactura.literal + _ctx.formatNumber2(_ctx.currentFactura.ncf)), 1)
        ]),
        _createElementVNode("h5", null, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.currentFactura.fechaFactura)), 1)
        ]),
        _createElementVNode("h5", null, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.currentFactura.vencimiento)), 1)
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h5", null, [
          _hoisted_15,
          _createElementVNode("span", null, _toDisplayString(this.currentFactura.rncReceptor), 1)
        ]),
        _createElementVNode("h5", null, [
          _hoisted_16,
          _createElementVNode("span", null, _toDisplayString(this.currentFactura.nombreRazonSocialReceptor), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("table", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatNumber(this.currentFactura.totalGeneral)), 1)
          ])
        ])
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.formatNumber(this.currentFactura.totalGeneral)), 1),
        _createElementVNode("h6", null, _toDisplayString(_ctx.formatNumber(this.currentFactura.descuento)), 1),
        _createElementVNode("h6", _hoisted_25, _toDisplayString(_ctx.formatNumber(this.currentFactura.totalGeneral)), 1)
      ])
    ])
  ]))
}